var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('page-heading',{attrs:{"title":_vm.$t((_vm.translationPrefix + ".title"))}}),_vm._v(" "),_c('el-card',[_c('h2',{attrs:{"align":"center"}},[_vm._v(_vm._s(_vm.$t((_vm.translationPrefix + ".messages.text"))))]),_vm._v(" "),_c('img',{staticClass:"logo horizontal",attrs:{"src":require("@/assets/img/logos/logo-h.png")}})])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0ecfd7f4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/NotAuthorized.vue
// module id = S3pj
// module chunks = 1